import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

export interface CompanyLeaderboardPlayer {
  email: string;
  learnerId: string;
  gamesPlayed: number;
  totalScore: number;
  name: string;
  rank: number;
}

export interface CompanyLeaderboardResponse {
  list: CompanyLeaderboardPlayer[];
  totalCount: number;
}

@Injectable({
  providedIn: 'root',
})
export class CompanyLeaderboardService {
  private apiUrl = `${environment.serverUrl}/learning-players/company-leaderboard`;

  constructor(private http: HttpClient) {}

  getLeaderboard(
    companyId: string,
    page: number,
    limit: number,
    email?: string,
  ): Observable<CompanyLeaderboardResponse> {
    let params = new HttpParams()
      .set('companyId', companyId)
      .set('page', page.toString())
      .set('limit', limit.toString());

    if (email) {
      params = params.set('email', email);
    }

    return this.http.get<CompanyLeaderboardResponse>(this.apiUrl, { params });
  }
}
